if (!customElements.get("delivery-time")) {
  customElements.define(
    "delivery-time",
    class Pincode extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("#main_pincode_form");
        this.form.querySelector("[name=pincode]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.deliveryTimeContainer = this.querySelector('[id="response1"]');
        this.deliveryTimeContainer1 = this.querySelector('[id="response2"]');
        this.deliveryTime = this.querySelector('[id="time1"]');
        this.deliveryTime2 = this.querySelector('[id="time2"]');
        this.submitButton = this.querySelector('[type="submit"]');
        if (localStorage.getItem("sddPincode")) {
          this.querySelector("#default__pincode").value = localStorage.getItem("sddPincode");
        }
        this.querySelector('#edt_change').addEventListener('click', () => {
          if (this.querySelector('#default__pincode').value.length > 0 && window.matchMedia("(max-width: 750px)").matches) {
            this.querySelector('.pincode_address_overlay').style.display = "flex";
            document.querySelector('.product_form_fixed_buttons').style.display = 'none';
          } else {
            this.querySelector("#response").style.display = "none";
            this.form.style.display = "flex";
          }
        });
        if (this.querySelector('#default__pincode').value.length > 0 && !window.location.href.includes('pincode')) {
          this.querySelector('#pincode__input').value = this.querySelector('#default__pincode').value;
          this.querySelector('.pincode_check').click();
        }
        document.querySelector('.pincode_check_2').addEventListener('click', () => {
          this.querySelector('#pincode__input').value = this.querySelector('#pincode__input_2').value;
          this.querySelector('.pincode_check').click();
          this.querySelector('.pincode_address_overlay').style.display = "none";
          document.querySelector('.product_form_fixed_buttons').style.display = 'block';
        });
        document.querySelector('.pincode_address_close').addEventListener('click', () => {
          this.querySelector('.pincode_address_overlay').style.display = "none";
          document.querySelector('.product_form_fixed_buttons').style.display = 'block';
        });
        document.querySelectorAll('[id^="cust_address_"]').forEach(element => {
          element.addEventListener('click', (e) => {
            this.querySelector('#pincode__input').value = element.value;
            this.querySelector('.pincode_check').click();
            this.querySelector('.pincode_address_overlay').style.display = "none";
            document.querySelector('.product_form_fixed_buttons').style.display = 'block';
          });
        });
        document.querySelector('#psedo-check').addEventListener('click', () => {
          document.querySelector("#pincode-response-error").style.display = "none";
          this.form.style.display = 'flex';
        });
      }

      setActiveAddress() {
        document.querySelectorAll('.pincode-address-option').forEach((element) => {
          if (element.querySelector('input').checked) {
            element.classList.add('active-pincode-address');
          } else {
            element.classList.remove('active-pincode-address');
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.deliveryTimeContainer1.style.display = "none";
        const data = new FormData(this.form);
        const pincode = data.get("pincode");
        const isMto = document.querySelector(".mto_customize") && document.querySelector("#inv_quan").value < 1;
        if (pincode && pincode.toString().length === 6) {
          this.submitButton.setAttribute("aria-disabled", true);
          const sku = data.get("sku");
          this.submitButton.innerHTML = '<div class="loader"></div>';
          let showCustomCart = localStorage.getItem("showCustomCart");
          if (showCustomCart === null) {
            setTimeout(() => this.form.requestSubmit(), 100);
            return;
          }
          const url = `https://prod.giva-api.com/getDeliveryTime?${sku.includes("PR") ? "perfume=true&" : ""
            }pin=${pincode}&sku=${sku}${sku.includes("PX") ? "&isPersonalised=true" : ""
            }${isMto ? "&isMto=yes" : ""}&zippee=false&${showCustomCart == "true" ? 'mode=custom' : 'shopify'}`;
          fetch(url)
            .then((response) => response.json())
            .then((response) => {
              console.log(response);
              this.setActiveAddress();
              this.querySelector("#response").style.display = "flex";
              this.form.style.display = "none";
              this.querySelector('#pincode__input_2').value = pincode;
              this.querySelector('#edt__location').innerHTML = pincode;
              this.deliveryTime.innerHTML =
                response.message.split("or Buy")[0];
              if (isMto) {
                this.deliveryTime.innerHTML = "Free Delivery by <strong>" + response.message.split("by ")[1] + ".<strong>";
              }
              this.deliveryTime2.innerHTML =
                "Or buy" + response.message.split("or Buy")[1];
              if (response.message === "Delivery code unserviceable") {
                this.deliveryTime.style.color = "#C50000";
                this.deliveryTime.style.fontWeight = "600";
              } else {
                this.deliveryTime.style.color = "#000000";
                this.deliveryTime.style.fontWeight = "400";
              }
              if (response.message.split("or Buy")[1]) {
                this.deliveryTimeContainer1.style.display = "flex";
                this.deliveryTimeContainer.style.borderRadius = '15px 15px 0 0';
              }
              if (document.querySelector("#product__sku").value.startsWith("GDL")) {
                if (response.status == 500) {
                  document.querySelector("#pincode-response-error").style.display = "flex";
                  this.form.style.display = 'none';
                  this.querySelector("#response").style.display = "none";
                } else {
                  document.querySelector("#pincode-response-error").style.display = "none";
                  document.querySelector("#custom_edt_input").value = pincode;
                  document.querySelector(".custom_edt_box").style.display = "none";
                  let resDate = response.message.split("by ")[1].split(". ")[0];
                  if (resDate.includes(", ")) {
                    resDate = resDate.split(", ")[1];
                  }
                  document.querySelector(".check-edt").innerHTML = "Free Delivery By <strong>" + resDate + "</strong>";
                  document.querySelector(".check-edt").style.color = "rgba(125, 125, 125, 1)";
                  document.querySelector(".check-edt-info").innerHTML = "Custom creations take a bit<br>more time, but the results are<br>worth the wait!";
                }
              }
            })
            .catch((err) => {
              console.log(err);
              this.deliveryTime.innerHTML =
                "<strong>Error occured in fetching the delivery time</strong>";
              this.deliveryTime.style.color = "#C50000";
            })
            .finally(() => {
              this.deliveryTimeContainer.style.display = "flex";
              this.submitButton.innerHTML = "<div>Check</div>";
            });
        } else {
          document.querySelector("#pincode-response-error").style.display = "flex";
          this.form.style.display = 'none';
          this.querySelector("#response").style.display = "none";
        }
      }
    }
  );
}
